import { render, staticRenderFns } from "./averagingAgreements.vue?vue&type=template&id=43fefff6&"
import script from "./averagingAgreements.vue?vue&type=script&lang=js&"
export * from "./averagingAgreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports